import { Dialog, styled } from '@mui/material';

export const StyledDialog:any = styled(Dialog)`
  & .MuiDialog-paper {
    box-shadow: none;
    overflow: visible;
    background-color: transparent;
  }

  & .MuiBackdrop-root {
    background: rgba(0, 0, 0, 0.8);
    /* Safari requires -webkit-backdrop-filter in addition to backdrop-filter */
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
  }
`;
